module.exports = __webpack_public_path__ + "static/img/MV20.8383afc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV20.jpg
// module id = F9Sx
// module chunks = 0